import { render, staticRenderFns } from "./BaseSidebarAdmin.vue?vue&type=template&id=3d293324&scoped=true&lang=pug"
import script from "./BaseSidebarAdmin.vue?vue&type=script&lang=ts"
export * from "./BaseSidebarAdmin.vue?vue&type=script&lang=ts"
import style0 from "./BaseSidebarAdmin.vue?vue&type=style&index=0&id=3d293324&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d293324",
  null
  
)

export default component.exports